import { ReactNode } from 'react'
import { Button, ButtonProps, alpha, darken, styled } from '@mui/material'
import { useIsDesktopSize } from '$common/react-hooks/layout'

// TODO it should be clear for color of button on hover
const StyledButton = styled(Button)(({ theme }) => ({
  color: theme.palette.neutral700,
  border: `1px solid ${alpha(theme.palette.neutral700, 0.5)}`,
  height: '40px',
  borderRadius: '12px',
  backgroundColor: theme.palette.neutral000,
  boxShadow: 'none',

  '&:hover, &:active': {
    backgroundColor: darken(theme.palette.neutral000, 0.1),
    boxShadow: 'none',
  },
}))

// TODO check for additional prop (needs logic)
interface PropTypes extends ButtonProps {
  text: string | ReactNode
}

export function CancelOutlinedButton({ text, ...props }: PropTypes) {
  const isDesktop = useIsDesktopSize()

  return (
    <StyledButton variant="contained" data-is-desktop={isDesktop} {...props}>
      {text}
    </StyledButton>
  )
}
